// Pure: derive the BOM panel rows from (graph, station). Same source of truth as
// the 3D scene, so the panel can never drift from what's rendered.

import { AssemblyGraph, StationId, BomItem, stationIndex } from "../graph/types";

export interface BomRow {
  itemId: number;
  item: BomItem;
  /** True when this item was added at the current station (highlight in panel). */
  isNew: boolean;
}

/**
 * BOM items visible at `station` = union of bomItems for every station at or
 * before `station` in process order. This mirrors the "<= current" visibility
 * rule so the panel and the geometry stay in lockstep regardless of nav order.
 */
export function computeBom(graph: AssemblyGraph, station: StationId): BomRow[] {
  const idx = stationIndex(station);
  const newIds = new Set(graph.stations[station].bomItems);

  const visibleIds = new Set<number>();
  for (const [id, def] of Object.entries(graph.stations)) {
    if (stationIndex(id) <= idx) {
      for (const b of def.bomItems) visibleIds.add(b);
    }
  }

  return [...visibleIds]
    .sort((a, b) => a - b)
    .filter((itemId) => graph.bom[itemId] != null)
    .map((itemId) => ({
      itemId,
      item: graph.bom[itemId],
      isNew: newIds.has(itemId),
    }));
}
